module.exports = __webpack_public_path__ + "static/liverpool-cathedral-577b53ad32d489c5d07c9072b522c90f.png";